import { FC, ReactNode } from 'react'
import FormItem from 'antd/es/form/FormItem'
import CourseDiscountModeFields from '../../CourseDiscountModeFields'
import type { CrmLinkDiscountMode } from '../../discountMode.utils'
import MonthlyCoursePeriodFields from './MonthlyCoursePeriodFields'
import type {
  MonthlyCourseLinkFieldType,
  MonthlyCourseLinkFieldsProps,
} from './types'

/**
 * UI-блок CRM-ссылки для помесячного тарифа (и class one_pay).
 * Без фиксации: скидка сверху + first_only/every_payment.
 * С фиксацией: скидка над «Итого» = renewal_only.
 */
const MonthlyCourseLinkFields: FC<MonthlyCourseLinkFieldsProps> = ({
  mode = 'course',
  isPeriodFixed,
  periodUnit,
  tariff,
  classAmount,
  periodValue,
  enrollDate,
  suggestedPrice,
  fullBasePrice,
  priceManuallyEdited,
  discountMode,
  onDiscountModeChange,
  onTogglePeriod,
  onPriceManualChange,
  onResetSuggestedPrice,
}) => {
  const renewalDiscountSlot: ReactNode = isPeriodFixed ? (
    <FormItem<MonthlyCourseLinkFieldType> name="discount" noStyle>
      <CourseDiscountModeFields
        variant="renewal_only"
        discountMode={discountMode}
        onDiscountModeChange={onDiscountModeChange}
        fullBasePrice={fullBasePrice}
      />
    </FormItem>
  ) : null

  return (
    <>
      {!isPeriodFixed ? (
        <FormItem<MonthlyCourseLinkFieldType> name="discount" noStyle>
          <CourseDiscountModeFields
            variant="first_payment"
            discountMode={discountMode}
            onDiscountModeChange={onDiscountModeChange}
            fullBasePrice={fullBasePrice}
          />
        </FormItem>
      ) : null}

      <FormItem<MonthlyCourseLinkFieldType> name="discount_mode" hidden>
        <input type="hidden" />
      </FormItem>
      <FormItem<MonthlyCourseLinkFieldType>
        name="apply_discount_each_payment"
        valuePropName="checked"
        hidden
      >
        <input type="checkbox" readOnly />
      </FormItem>

      <MonthlyCoursePeriodFields
        mode={mode}
        isPeriodFixed={isPeriodFixed}
        periodUnit={periodUnit}
        tariff={tariff}
        classAmount={classAmount}
        periodValue={periodValue}
        enrollDate={enrollDate}
        suggestedPrice={suggestedPrice}
        priceManuallyEdited={priceManuallyEdited}
        renewalDiscountSlot={renewalDiscountSlot}
        onTogglePeriod={onTogglePeriod}
        onPriceManualChange={onPriceManualChange}
        onResetSuggestedPrice={onResetSuggestedPrice}
      />
    </>
  )
}

export default MonthlyCourseLinkFields
